import React, { Component } from "react";
import { connect } from "react-redux";
import IntlMessages from "../../../utils/IntlMessages";
import { switchLanguage, languageClosePopup } from "../../../actions";
import lang_en from "../../../assets/images/en.png";
import lang_th from "../../../assets/images/th.png";

class PopupLanguage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeLang: this.props.locale,
    };
  }

  onClickClose = (e) => {
    this.props.languageClosePopup();
    this.setState({
      activeLang: this.props.locale,
    });
  };
  onClickSelect = () => {
    if (this.state.activeLang === "th") {
      this.props.switchLanguage({
        languageId: "thai",
        locale: "th",
        name: "Thai",
        icon: "th",
      });
    } else {
      this.props.switchLanguage({
        languageId: "english",
        locale: "en",
        name: "English",
        icon: "en",
      });
    }
    this.props.languageClosePopup();
  };

  toggleLang = (lang) => {
    this.setState({
      activeLang: lang,
    });
  };
  render() {
    let btnClass = "btn btn-wrs-lang";
    let btnClassCancel = "btn btn-wrs-lang-clear";
    if (!this.props.displayPopupLanguage) {
      return <div></div>;
    }
    let tabTh, tabEn;
    if (this.state.activeLang === "en") {
      tabTh = "";
      tabEn = "icon-ico-check";
    } else {
      tabTh = "icon-ico-check";
      tabEn = "";
    }

    return (
      <div
        className="modal fade show"
        role="dialog"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-language modal-sm"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-body">
              <div
                onClick={() => {
                  this.toggleLang("en");
                }}
              >
                <img src={lang_en} alt="Abbott" /> English{" "}
                <i className={tabEn}></i>
              </div>
              <div
                onClick={() => {
                  this.toggleLang("th");
                }}
              >
                <img src={lang_th} alt="Abbott" /> ภาษาไทย - Thai{" "}
                <i className={tabTh}></i>
              </div>
            </div>
            <div className="modal-foot">
              <button
                type="button"
                className={btnClassCancel}
                onClick={this.onClickClose}
              >
                <IntlMessages id="popup.close"></IntlMessages>
              </button>
              <button
                type="button"
                className={btnClass}
                onClick={this.onClickSelect}
              >
                <IntlMessages id="popup.lang-select"></IntlMessages>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ setting, language: { displayPopupLanguage } }) => {
  const {
    locale: { locale },
  } = setting;
  return { locale, displayPopupLanguage };
};

export default connect(mapStateToProps, {
  languageClosePopup,
  switchLanguage,
})(PopupLanguage);
